import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/sw-register";
import { installNativeDialogFocusFix } from "@/lib/nativeDialogFocusFix";

// Restore keyboard focus after native dialogs (Electron/Windows quirk).
installNativeDialogFocusFix();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
